import { Controller } from "@hotwired/stimulus";
import { marked } from "marked";

// Bold, italic, link, and list buttons that transform the textarea selection, plus a
// preview toggle rendered by marked. The textarea stays the source of truth, so what we
// store is plain markdown.
export default class extends Controller {
  static targets = ["input", "preview", "toggle"];

  bold() {
    this.wrap("**", "**", "bold text");
  }

  italic() {
    this.wrap("*", "*", "italic text");
  }

  link() {
    const url = window.prompt("Link URL");
    if (!url) return;
    this.wrap("[", `](${url})`, "link text");
  }

  bulletList() {
    this.prefixLines(() => "- ", "List item");
  }

  numberedList() {
    this.prefixLines((index) => `${index + 1}. `, "List item");
  }

  togglePreview() {
    if (this.previewTarget.hidden) {
      // Escape the angle brackets before rendering so the markdown marks still work but a
      // stray <tag> in the admin's own input shows as text instead of running as markup.
      const source = (this.inputTarget.value || "").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      this.previewTarget.innerHTML = marked.parse(source);
      this.inputTarget.hidden = true;
      this.previewTarget.hidden = false;
      this.toggleTarget.textContent = "Edit";
    } else {
      this.previewTarget.hidden = true;
      this.inputTarget.hidden = false;
      this.toggleTarget.textContent = "Preview";
    }
  }

  wrap(before, after, placeholder) {
    const el = this.inputTarget;
    const { selectionStart, selectionEnd, value } = el;
    const selected = value.slice(selectionStart, selectionEnd) || placeholder;
    el.value = value.slice(0, selectionStart) + before + selected + after + value.slice(selectionEnd);
    el.focus();
    const cursor = selectionStart + before.length;
    el.setSelectionRange(cursor, cursor + selected.length);
  }

  prefixLines(marker, placeholder) {
    const el = this.inputTarget;
    const { selectionStart, selectionEnd, value } = el;
    const blockStart = value.lastIndexOf("\n", selectionStart - 1) + 1;
    const anchorEnd = selectionEnd > selectionStart ? selectionEnd - 1 : selectionEnd;
    const nextBreak = value.indexOf("\n", anchorEnd);
    const blockEnd = nextBreak === -1 ? value.length : nextBreak;
    const block = value.slice(blockStart, blockEnd) || placeholder;
    const prefixed = block
      .split("\n")
      .map((line, index) => marker(index) + line)
      .join("\n");
    el.value = value.slice(0, blockStart) + prefixed + value.slice(blockEnd);
    el.focus();
    el.setSelectionRange(blockStart, blockStart + prefixed.length);
  }
}
